import { combineReducers } from 'redux';

import adminPageInfo from './admin';
import doorsAndSections from './doorsAndSections';
import navigation from './navigation';
import footer from './footer';
import fillingMaterials from './fillingMaterials';
import config from './config';
import order from './order';
import priceList from './priceList';
import signupForm from './signupForm';
import signinForm from './signinForm';
import signinAdminForm from './signinAdminForm';
import signinManagerForm from './signinManagerForm';
import profile from './profile';
import tfaForm from './tfaForm';
import forgotPasswordForm from './forgotPasswordForm';
import myAcceptedOrders from './myAcceptedOrders';
import mySavedOrders from './mySavedOrders';
import systems from './systems';
import delivery from './delivery';
import auth from './auth';
import clientList from './clientList';
import discounts from './discounts';
import drillingHoles from './drillingHoles';
import fasteningElement from './fasteningElement';
import drillingPearHoles from './drillingPearHoles';

const reducers = combineReducers({
  adminPageInfo,
  doorsAndSections,
  navigation,
  footer,
  fillingMaterials,
  config,
  priceList,
  order,
  signupForm,
  signinForm,
  signinAdminForm,
  signinManagerForm,
  profile,
  tfaForm,
  forgotPasswordForm,
  myAcceptedOrders,
  mySavedOrders,
  systems,
  delivery,
  auth,
  clientList,
  discounts,
  drillingHoles,
  fasteningElement,
  drillingPearHoles,
});

export default reducers;
